import { useQuery } from '@tanstack/react-query';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getContentCategories = ({ pageId }: contentApiTypes.ListCategoriesParams) => {
  return axios.get('/content/categories', {
    params: { pageId },
  }) as Promise<contentApiTypes.ListCategoriesResponse>;
};

type QueryFnType = typeof getContentCategories;

type UseGetContentCategoriesOptions = {
  pageId?: string | null;
  config?: QueryConfig<QueryFnType>;
};

export const useGetContentCategories = ({
  pageId,
  config = {},
}: UseGetContentCategoriesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['content-categories', pageId],
    enabled: Boolean(pageId) && (config.enabled ?? true),
    queryFn: () => getContentCategories({ pageId: pageId! }),
    // Global default is refetchOnMount:false; refetch so new/edited categories
    // appear without a full page reload.
    refetchOnMount: true,
  });
};

export type ContentCategoriesQueryData = ExtractFnReturnType<QueryFnType>;
